import api from './client';
import { League, LeagueMemberWithAccount } from '../types';

export const leaguesApi = {
  // Get league by ID
  async getLeague(leagueId: string): Promise<{
    league: League;
    members: LeagueMemberWithAccount[];
  }> {
    const { data } = await api.get(`/leagues/${leagueId}`);
    return data;
  },

  // Get league members with rating stats
  async getLeagueMembers(leagueId: string): Promise<LeagueMemberWithAccount[]> {
    const { data } = await api.get<LeagueMemberWithAccount[]>(
      `/leagues/${leagueId}/members`
    );
    return data;
  },

  // Search leagues
  async searchLeagues(
    query: string,
    options?: { limit?: number; offset?: number }
  ): Promise<League[]> {
    const { data } = await api.get<League[]>('/leagues/search', {
      params: { q: query, ...options },
    });
    return data;
  },

  // Get leagues by season
  async getLeaguesBySeason(
    season: string,
    options?: { limit?: number; offset?: number }
  ): Promise<League[]> {
    const { data } = await api.get<League[]>(`/leagues/season/${season}`, {
      params: options,
    });
    return data;
  },

  // Refresh league data from Sleeper
  async refreshLeague(leagueId: string): Promise<{
    league: League;
    members: LeagueMemberWithAccount[];
    message: string;
  }> {
    const { data } = await api.post(`/leagues/${leagueId}/refresh`);
    return data;
  },
};

